import { ReactNode } from 'react';

import { RiAddLine } from '@remixicon/react';

import { Button } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

export type PageContentActionBarCreateButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  disabledReason?: ReactNode;
  isVisuallyDisabled?: boolean;
  'aria-disabled'?: boolean;
  'data-testid'?: string;
  children?: ReactNode;
};

export const ContentActionBarCreateButton = ({
  onClick,
  disabled,
  disabledReason,
  isVisuallyDisabled,
  'aria-disabled': ariaDisabled,
  children = 'Create',
  ...rest
}: PageContentActionBarCreateButtonProps) => {
  const showDisabledReason = Boolean(disabled && disabledReason);
  const button = (
    <Button
      variant="primary"
      onClick={ariaDisabled || showDisabledReason ? undefined : onClick}
      disabled={disabled && !showDisabledReason}
      isVisuallyDisabled={isVisuallyDisabled || showDisabledReason}
      aria-disabled={ariaDisabled || showDisabledReason}
      {...rest}
    >
      <RiAddLine />
      {children}
    </Button>
  );

  if (!showDisabledReason) return button;

  return (
    <TooltipRoot>
      {button}
      <Tooltip>{disabledReason}</Tooltip>
    </TooltipRoot>
  );
};
